/*
 * File: icon.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:37:59
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "@root/components/base-classes";

/// refined at 2023/12/12
@Component
export default class Icon extends BaseComponent {
    @Prop({ type: String, required: true })
    icon!: string;

    @Prop({ type: Boolean, default: false })
    yiq!: boolean;

    /// private helper
    get classIcon() {
        return `d-inline-block ${this.icon} icon-${this.size} text-${this.variant}${
            this.yiq ? "-yiq" : ""
        }`;
    }
}
